import { injectIntl } from "react-intl";
import React from "react";
import { Link } from "react-router-dom";
import { PageEnum } from "src/helpers/Enums";

const Header = () => {
  return (
    <div className={"DashboardPageHeader"}>
      <div className={"PageHeaderTitle"}>{PageEnum.DASHBOARD}</div>
      <Link
        to="/publicDashboard"
        target="_blank"
        rel="noopener noreferrer"
        className="flex h-[36px] px-3 mr-6 justify-center items-center gap-1.5 rounded-lg border border-[#E5E7F0] bg-white text-[#15151F] text-xs font-semibold"
        style={{
          boxShadow: "0 1px 2px 0 rgba(21, 21, 31, 0.05)",
          fontFamily: "Inter",
        }}
      >
        <img alt="" src="/media/icons/eye.svg" className="w-4 h-4" />
        Public Top Offers
      </Link>
    </div>
  );
};

export default injectIntl(Header);